<!-- Finder expansible de Documentos de Expedientes -->

<template>
  <div class="exp_docs_XM" v-if="schema">      
    <v-sheet :elevation="4">

      <!-- Botones Mto -->
      <div class="pt-2 d-flex justify-left">
        <!-- Mto -->            
        <btramto          
          :btra_permisos="schema.btra"
          :btra_particular="Entorno.btra"
          btra_modulo="xm"
          :estado="estado"
          @onEvent="event_btra_Mto">                
        </btramto>     
      </div>

      <!-- Controles del Mto -->
      <div class="contenedor">  
        <div style="display:flex"> 
          <v-text-field
            style="flex: 0 0 60%"
            v-bind="$input"
            v-model="schema.ctrls.nom.value"
            :label="schema.ctrls.nom.label"
            :disabled="!is_edit">
          </v-text-field>

          <v-select
            style="flex: 0 0 40%"
            v-bind="$select"
            v-model="schema.ctrls.tpd.value"
            :label="schema.ctrls.tpd.label"
            :items="itemsTipoDoc"
            :disabled="!is_edit"
            item-value="id"
            item-text="name">
          </v-select>
        </div>
        
        <v-textarea
          v-bind="$textarea"
          v-model="schema.ctrls.des.value"
          :label="schema.ctrls.des.label"
          no-resize
          :disabled="!is_edit">
        </v-textarea>

        <v-file-input
          v-model="files"
          accept="application/pdf"
          chips
          clearable
          dense
          rounded
          small-chips
          :disabled="estado != 'nuevo'">
        </v-file-input>                    

        <div style="display:flex"> 
          <div>Factura/Suplido (Debe indicar si corresponse a una Factura o a un Suplido específico)</div>
        </div>

        <div style="display:flex">
          <v-select
            style="flex: 0 0 60%"
            v-bind="$select"
            v-model="get_fra"
            :label="schema.ctrls.fra.label"
            :items="itemsFactura"
            :disabled="!is_edit"
            item-value="d"
            item-text="n"
            @change="change_fra">
          </v-select>

          <v-checkbox            
            v-bind="$checkbox"
            v-model="schema.ctrls.ca24.value"
            :label="schema.ctrls.ca24.label"
            :disabled="!is_edit">
          </v-checkbox>

          <v-checkbox            
            v-bind="$checkbox"
            v-model="schema.ctrls.apd.value"
            :label="schema.ctrls.apd.label"
            :disabled="!is_edit">
          </v-checkbox>

          <v-checkbox            
            v-bind="$checkbox"
            v-model="schema.ctrls.jzo.value"
            :label="schema.ctrls.jzo.label"
            :disabled="!is_edit">
          </v-checkbox>

          <v-checkbox            
            v-bind="$checkbox"
            v-model="schema.ctrls.cia.value"
            :label="schema.ctrls.cia.label"
            :disabled="!is_edit">
          </v-checkbox>

          <v-checkbox            
            v-bind="$checkbox"
            v-model="schema.ctrls.fun.value"
            :label="schema.ctrls.fun.label"
            :disabled="!is_edit">
          </v-checkbox>
        </div>

        <div style="display:flex">
          <compfecha :schema="schema.ctrls.fhhr" :edicion="false"></compfecha>         
          
          <v-text-field
            v-bind="$input"
            v-model="schema.ctrls.usu.value"
            :label="schema.ctrls.usu.label"
            :disabled="true">
          </v-text-field>
        </div>
      </div>
    </v-sheet>       
  </div>
</template>



<script>

  import { mixinMto } from "@/mixins/mixinMto.js"; 
  import { mixinDocs_XM } from "@/mixins/mixinDocs_XM.js"; 
  import plugs from "@/common/general_plugs";  
  const btramto = () => plugs.groute("btramto.vue", "comp");    
  const compfecha = () => plugs.groute("compfecha.vue", "comp");
    
  export default {
    mixins: [mixinMto, mixinDocs_XM],
    components: { btramto, compfecha },
    props: {
      padre: { type:String, default: '' }, 
      id: { type:String, default: '' },   
      accion: { type:[Number, String], default: ''},
      accionRow: { type:Object, default: ()=> {}}, 
      disparo: { type:Boolean, default:false }, 
      componenteTipo: { type:String, default:'M' },
      tip: { type:Number, default:0 },    
      Entorno: { type: Object, default: function() { return JSON.parse(JSON.stringify(this.$cfg.base.M)); }}
    },


    data() {
      return {
        schema: null,       
        api:'exp_Docs_M',
        stName:'stMexp_docs',
        disparoFinder:false,
        
        campo_relacionado: "tip_id",
        tabla:1,
        files:null,
        itemsTipoDoc:[],       
        itemsFactura:[]        
      };
    },  


    computed: {
      get_fra: {
        get() {
          console.log('get get_fra: ', this.accionRow); 
          if (this.estado== 'nuevo') return "0";
          if (Number(this.accionRow.sup_id)> "0") return this.accionRow.sup_id;
          return this.accionRow.fra_id;
        },

        set(d) {          
          let itemFra= this.itemsFactura.find(item => item.d == d);
          this.schema.ctrls.fra.value= itemFra.fra;
          this.schema.ctrls.fra.value= itemFra.fra;
          console.log('set get_fra: ', itemFra);
        }
        
      }
    },


    methods: {
      ini_data() { 
        console.log("DEV " + this.api + " ********************** (ini_data)");

        // guardo del store en variables locales
        this.schema = this.$store.state[this.stName].schema;  
        
        // configuro Entorno        
        this.Entorno.header.header= false;    
        this.Entorno.btra= "XM";        
        
        // items adicionales
        // tipo de documento
        this.itemsTipoDoc= JSON.parse(JSON.stringify(this.$store.state.datos_iniciales.tipo_documento));
        this.itemsTipoDoc= this.itemsTipoDoc.filter(elem => elem.modulos.charAt(this.tip== 1));      
        
        // facturas expedientes
        this.itemsFactura= JSON.parse(JSON.stringify(this.$store.state[this.padre].recordsDetalle[2]));
        this.itemsFactura.unshift({ d:"0", n:"Selecciona una Factura/Suplido" });
      },


      // guardo item fra seleccionada
      change_fra(d) {             
        let itemFra= this.itemsFactura.find(item => item.d == d);
        
        // actualizo el control de suplido con el dato de la fra
        this.schema.ctrls.sup.value= itemFra.sup;                
      }

    }
};
</script>
